import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Layout.module.css';
import LayoutColumn from './components/LayoutColumn';
import AnnotatedSection from './components/AnnotatedSection';

const Layout = ({
  children,
  maxWidth,
  dataId,
}) => {
  const bindClasses = classNameBind.bind(styles);
  const validChild = child => child.type === Layout.Column || child.type === Layout.AnnotatedSection;
  const columns = React.Children.map(children, child => (validChild(child) ? child : null));
  const childrenToRender = columns.length === 0 ? <Layout.Column>{children}</Layout.Column> : columns;

  return (
    <div
      className={bindClasses('outer')}
      data-ppuc-id={dataId}
    >
      <div className={bindClasses('inner', `maxWidth-${maxWidth}`)}>
        {childrenToRender}
      </div>
    </div>
  );
};

Layout.defaultProps = {
  children: null,
  maxWidth: 'wide',
  dataId: 'Layout',
};

Layout.Column = LayoutColumn;
Layout.AnnotatedSection = AnnotatedSection;

export default Layout;
